export const isUserDistrictAdmin = (userDetails) => {
    const { roleDtos } = userDetails || [];
    return roleDtos?.length > 0 && roleDtos?.find((role) => role.role === "EPR_ADMIN");
};

export const isUserSchoolAdmin = (userDetails) => {
    const { roleDtos } = userDetails || [];
    return (
        roleDtos?.length > 0 &&
        roleDtos?.find((role) => role.role === "PRINCIPAL" || role.role === "ASSISTANT_PRINCIPAL")
    );
};

export const isUserTeacher = (userDetails) => {
    const { roleDtos } = userDetails || [];
    return roleDtos?.length > 0 && roleDtos?.find((role) => role.role === "TEACHER");
};

export const hasRole = (userDetails, roles = []) => {
    const { roleDtos } = userDetails || [];
    return roleDtos?.length > 0 && roleDtos?.find((r) => roles.includes(r.role));
};

export const isUserPk12 = (userDetails) => {
    return hasRole(userDetails, ["PK12"]);
};

export const canAdminBypassGradingWindow = (userDetails) =>
    Boolean(isUserDistrictAdmin(userDetails) || isUserPk12(userDetails) || isUserSchoolAdmin(userDetails));

export const canAdminCancelRelease = canAdminBypassGradingWindow;
